<app-top-navbar [title]="'profiles.new.title' | translate"/>
@if (isMemberChecked) {
  <div class="wrapper page-new-profile">
    <app-loyalty-club-header/>
    <div class="content">
      @switch (flowStep) {
        @case (FLOW_STEPS.form) {
          <app-profile-form
              [data]="prefilledData"
              [isNewProfile]="true"
              [formErrors]="formErrors"
              (save)="onProfileSave($event)"/>
        }
        @case (FLOW_STEPS.recaptchaCheckbox) {
          <app-recaptcha (data)="recaptchaCheckboxDataGenerated($event)"/>
        }
        @case (FLOW_STEPS.otpInput) {
          <form (ngSubmit)="submitSecondStep()"
                [class.submitted]="isSecondStepSubmitted">
            <app-msisdn-input class="field-msisdn"
                              [readonly]="true"
                              [passedFormControl]="msisdnControl"
                              [showErrors]="true"/>
            <div [class]="{
              'input--filled': !!otpFormControl.value,
              'has-error': formErrors['registration_password']
              }"
                 class="form-group label-static is-empty tw-mb-[60px] form-control-registration-password">
              <label class="control-label">
                <span>{{ 'generic.otp_password' | translate }}</span>
                <span class="required">*</span>
              </label>
              <input class="form-control field-registration_password"
                     [formControl]="otpFormControl"
                     type="password">
              @if (!formErrors['registration_password']) {
                <div class="help-block visible">
                  <a [class.disabled]="isPasswordSending"
                     (click)="resendOTP()">{{ 'generic.resend_otp_password' | translate }}</a>
                  @if (isPasswordSent) {
                    <span class="text-info tw-ml-4">{{ 'generic.password_sent_info' | translate }}</span>
                  }
                </div>
              }
              <app-input-errors [errorsForField]="formErrors['registration_password']"
                                [translationKey]="'errors.members'"/>
            </div>
            @if (showCaptchaCheckbox) {
              <app-password-resend-captcha (captchaFinished)="recaptchaCheckboxDataGeneratedForOtpStep($event)"/>
            }
            <button class="btn btn-lg btn-raised btn-primary btn-block">
              <span>{{ 'profiles.new.submit_button' | translate }}</span>
            </button>
            <app-recaptcha-info/>
          </form>
        }
      }
    </div>
    <app-loyalty-club-footer/>
  </div>
}
